import { Badge, Descriptions, Typography, Skeleton, Image } from "antd";
import { OrderLocation } from "../../Orders/OrderLocation";
import moment from "moment";
import { useState } from "react";

const { Text, Link } = Typography;

export default function OrderDescription(props) {
  const data = props.data;
  const [showImage, setShowImage] = useState(false);

  if (!data) {
    return null; // or render an error message
  }

  const product = data.selectedProduct;

  if (props.loading) {
    return (
      <>
        <Skeleton active />;
      </>
    );
  }

  return (
    <>
      <Descriptions size="small">
        <Descriptions.Item label="Order ID">
          <Text copyable>{data.id}</Text>
        </Descriptions.Item>
        <Descriptions.Item label="Client">{data.client.client}</Descriptions.Item>
        <Descriptions.Item label="Product">{product.product.productName}</Descriptions.Item>
        <Descriptions.Item label="Location">
          <Badge status="processing" text={OrderLocation(data.orderStatus)} />
        </Descriptions.Item>

        <Descriptions.Item label="Manager">{data.user}</Descriptions.Item>
        <Descriptions.Item label="Manufacturer">{data.manufacturer.company}</Descriptions.Item>
        <Descriptions.Item label="Creation Date">{moment.unix(data.created.seconds).format("LLL")}</Descriptions.Item>
        <Descriptions.Item label="User Uploaded File">
          <Link type="text" rel="noreferrer" target="_blank" href={product.product.productFileUrl}>
            Link
          </Link>
        </Descriptions.Item>
        <Descriptions.Item label="Technical">
          <Image
            src={product.technicalPage}
            style={{
              display: "none",
            }}
            preview={{
              visible: showImage,
              onVisibleChange: (value) => {
                setShowImage(value);
              },
            }}
          />
          <Link onClick={() => setShowImage(true)}>Show technical</Link>
        </Descriptions.Item>
        <Descriptions.Item label="Sales Comment">{data.salesComment}</Descriptions.Item>
      </Descriptions>
    </>
  );
}
